<template>
  <div class="screen">
    <v-tabs color="secondary" fixed-tabs v-model="tab">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab>
        Attended
      </v-tab>
      <v-tab>
        Presented
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <eventlist v-bind:presentations="allAttended" itemLink="presentation"></eventlist>
      </v-tab-item>
      <v-tab-item>
        <eventlist v-bind:presentations="allPresented" itemLink="presentation"></eventlist>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  name: 'AttendList',
  data() {
    return {
      tab: null,
      allAttended: null,
      allPresented: null
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/AllPresentations.vue